export default {
  error: 'Feil',
  sorry: 'Beklager, vi har mottatt følgende feil',
  workingOnIt:
    'En ingeniør har blitt varslet om dette problemet, og vi arbeider for å løse det så raskt som mulig.',
  tryAgain: 'Prøv igjen senere',
  noInternet:
    'Det ser ut til å være et problem med din Internett-tilkobling. Vennligst sjekk og prøv igjen.',
}
